// composables/useSafeFetch.ts
import { translate } from "../utils/domainLocales";

export async function useSafeFetch<T>(
  url: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: any = {},
  fallback: T | null = null,
): Promise<T | null> {
  try {
    return await $fetch<T>(url, options);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    useBugsnag().notify(error, (event) => {
      event.addMetadata("fetch", {
        url,
        options,
      });
    });

    const title = error?.data?.data?.name ?? translate("errors.default-title");
    const text =
      error?.data?.data?.message ?? translate("errors.default-message");

    create({
      title,
      text,
      type: "error",
    });

    return fallback;
  }
}
